import { jsx as f, Fragment as Y, jsxs as P } from "react/jsx-runtime";
import * as a from "react";
import { forwardRef as Z, useState as J, useEffect as Q } from "react";
import { c as A } from "./index-SYE1cn5_.js";
import { L as H } from "./Label-DMBnN1_E.js";
import { T as x } from "./Text-D6i4LEWL.js";
import { r as V } from "./index-2hJuj4UN.js";
import { c as M, R as ee, I as te } from "./index-DxaoG5hx.js";
import { u as re } from "./index-CqxPlD6w.js";
import { u as ne } from "./index-BZPx6jYI.js";
import { I as oe } from "./Input-DFqMEdAg.js";
function C(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), r === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function ie(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function O(...e) {
  return (t) => e.forEach((r) => ie(r, t));
}
function b(...e) {
  return a.useCallback(O(...e), e);
}
function k(e, t = []) {
  let r = [];
  function n(i, c) {
    const s = a.createContext(c), d = r.length;
    r = [...r, c];
    function u(l) {
      const { scope: v, children: p, ...R } = l, y = (v == null ? void 0 : v[e][d]) || s, _ = a.useMemo(() => R, Object.values(R));
      return /* @__PURE__ */ f(y.Provider, { value: _, children: p });
    }
    function m(l, v) {
      const p = (v == null ? void 0 : v[e][d]) || s, R = a.useContext(p);
      if (R) return R;
      if (c !== void 0) return c;
      throw new Error(`\`${l}\` must be used within \`${i}\``);
    }
    return u.displayName = i + "Provider", [u, m];
  }
  const o = () => {
    const i = r.map((c) => a.createContext(c));
    return function(s) {
      const d = (s == null ? void 0 : s[e]) || i;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: d } }),
        [s, d]
      );
    };
  };
  return o.scopeName = e, [n, ae(o, ...t)];
}
function ae(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const c = n.reduce((s, { useScope: d, scopeName: u }) => {
        const l = d(i)[`__scope${u}`];
        return { ...s, ...l };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: c }), [c]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
var G = a.forwardRef((e, t) => {
  const { children: r, ...n } = e, o = a.Children.toArray(r), i = o.find(ce);
  if (i) {
    const c = i.props.children, s = o.map((d) => d === i ? a.Children.count(c) > 1 ? a.Children.only(null) : a.isValidElement(c) ? c.props.children : null : d);
    return /* @__PURE__ */ f(S, { ...n, ref: t, children: a.isValidElement(c) ? a.cloneElement(c, void 0, s) : null });
  }
  return /* @__PURE__ */ f(S, { ...n, ref: t, children: r });
});
G.displayName = "Slot";
var S = a.forwardRef((e, t) => {
  const { children: r, ...n } = e;
  if (a.isValidElement(r)) {
    const o = de(r);
    return a.cloneElement(r, {
      ...ue(n, r.props),
      // @ts-ignore
      ref: t ? O(t, o) : o
    });
  }
  return a.Children.count(r) > 1 ? a.Children.only(null) : null;
});
S.displayName = "SlotClone";
var se = ({ children: e }) => /* @__PURE__ */ f(Y, { children: e });
function ce(e) {
  return a.isValidElement(e) && e.type === se;
}
function ue(e, t) {
  const r = { ...t };
  for (const n in t) {
    const o = e[n], i = t[n];
    /^on[A-Z]/.test(n) ? o && i ? r[n] = (...s) => {
      i(...s), o(...s);
    } : o && (r[n] = o) : n === "style" ? r[n] = { ...o, ...i } : n === "className" && (r[n] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function de(e) {
  var n, o;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var le = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], I = le.reduce((e, t) => {
  const r = a.forwardRef((n, o) => {
    const { asChild: i, ...c } = n, s = i ? G : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ f(s, { ...c, ref: o });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function D(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => (...r) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...r);
  }, []);
}
function fe({
  prop: e,
  defaultProp: t,
  onChange: r = () => {
  }
}) {
  const [n, o] = pe({ defaultProp: t, onChange: r }), i = e !== void 0, c = i ? e : n, s = D(r), d = a.useCallback(
    (u) => {
      if (i) {
        const l = typeof u == "function" ? u(e) : u;
        l !== e && s(l);
      } else
        o(u);
    },
    [i, e, o, s]
  );
  return [c, d];
}
function pe({
  defaultProp: e,
  onChange: t
}) {
  const r = a.useState(e), [n] = r, o = a.useRef(n), i = D(t);
  return a.useEffect(() => {
    o.current !== n && (i(n), o.current = n);
  }, [n, o, i]), r;
}
var me = a.createContext(void 0);
function ve(e) {
  const t = a.useContext(me);
  return e || t || "ltr";
}
var w = globalThis != null && globalThis.document ? a.useLayoutEffect : () => {
};
function Re(e, t) {
  return a.useReducer((r, n) => t[r][n] ?? r, e);
}
var T = (e) => {
  const { present: t, children: r } = e, n = ye(t), o = typeof r == "function" ? r({ present: n.isPresent }) : a.Children.only(r), i = b(n.ref, he(o));
  return typeof r == "function" || n.isPresent ? a.cloneElement(o, { ref: i }) : null;
};
T.displayName = "Presence";
function ye(e) {
  const [t, r] = a.useState(), n = a.useRef({}), o = a.useRef(e), i = a.useRef("none"), c = e ? "mounted" : "unmounted", [s, d] = Re(c, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return a.useEffect(() => {
    const u = N(n.current);
    i.current = s === "mounted" ? u : "none";
  }, [s]), w(() => {
    const u = n.current, m = o.current;
    if (m !== e) {
      const v = i.current, p = N(u);
      e ? d("MOUNT") : p === "none" || (u == null ? void 0 : u.display) === "none" ? d("UNMOUNT") : d(m && v !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, d]), w(() => {
    if (t) {
      const u = (l) => {
        const p = N(n.current).includes(l.animationName);
        l.target === t && p && V.flushSync(() => d("ANIMATION_END"));
      }, m = (l) => {
        l.target === t && (i.current = N(n.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      d("ANIMATION_END");
  }, [t, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: a.useCallback((u) => {
      u && (n.current = getComputedStyle(u)), r(u);
    }, [])
  };
}
function N(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function he(e) {
  var n, o;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var E = "Radio", [Ne, L] = k(E), [_e, Ce] = Ne(E), U = a.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: r,
      name: n,
      checked: o = !1,
      required: i,
      disabled: c,
      value: s = "on",
      onCheck: d,
      ...u
    } = e, [m, l] = a.useState(null), v = b(t, (y) => l(y)), p = a.useRef(!1), R = m ? !!m.closest("form") : !0;
    return /* @__PURE__ */ P(_e, { scope: r, checked: o, disabled: c, children: [
      /* @__PURE__ */ f(
        I.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": F(o),
          "data-disabled": c ? "" : void 0,
          disabled: c,
          value: s,
          ...u,
          ref: v,
          onClick: C(e.onClick, (y) => {
            o || d == null || d(), R && (p.current = y.isPropagationStopped(), p.current || y.stopPropagation());
          })
        }
      ),
      R && /* @__PURE__ */ f(
        Se,
        {
          control: m,
          bubbles: !p.current,
          name: n,
          value: s,
          checked: o,
          required: i,
          disabled: c,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
U.displayName = E;
var q = "RadioIndicator", W = a.forwardRef(
  (e, t) => {
    const { __scopeRadio: r, forceMount: n, ...o } = e, i = Ce(q, r);
    return /* @__PURE__ */ f(T, { present: n || i.checked, children: /* @__PURE__ */ f(
      I.span,
      {
        "data-state": F(i.checked),
        "data-disabled": i.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    ) });
  }
);
W.displayName = q;
var Se = (e) => {
  const { control: t, checked: r, bubbles: n = !0, ...o } = e, i = a.useRef(null), c = ne(r), s = re(t);
  return a.useEffect(() => {
    const d = i.current, u = window.HTMLInputElement.prototype, l = Object.getOwnPropertyDescriptor(u, "checked").set;
    if (c !== r && l) {
      const v = new Event("click", { bubbles: n });
      l.call(d, r), d.dispatchEvent(v);
    }
  }, [c, r, n]), /* @__PURE__ */ f(
    "input",
    {
      type: "radio",
      "aria-hidden": !0,
      defaultChecked: r,
      ...o,
      tabIndex: -1,
      ref: i,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function F(e) {
  return e ? "checked" : "unchecked";
}
var Pe = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], g = "RadioGroup", [be, Xe] = k(g, [
  M,
  L
]), j = M(), $ = L(), [Ie, Ee] = be(g), B = a.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: r,
      name: n,
      defaultValue: o,
      value: i,
      required: c = !1,
      disabled: s = !1,
      orientation: d,
      dir: u,
      loop: m = !0,
      onValueChange: l,
      ...v
    } = e, p = j(r), R = ve(u), [y, _] = fe({
      prop: i,
      defaultProp: o,
      onChange: l
    });
    return /* @__PURE__ */ f(
      Ie,
      {
        scope: r,
        name: n,
        required: c,
        disabled: s,
        value: y,
        onValueChange: _,
        children: /* @__PURE__ */ f(
          ee,
          {
            asChild: !0,
            ...p,
            orientation: d,
            dir: R,
            loop: m,
            children: /* @__PURE__ */ f(
              I.div,
              {
                role: "radiogroup",
                "aria-required": c,
                "aria-orientation": d,
                "data-disabled": s ? "" : void 0,
                dir: R,
                ...v,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
B.displayName = g;
var K = "RadioGroupItem", z = a.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: r, disabled: n, ...o } = e, i = Ee(K, r), c = i.disabled || n, s = j(r), d = $(r), u = a.useRef(null), m = b(t, u), l = i.value === o.value, v = a.useRef(!1);
    return a.useEffect(() => {
      const p = (y) => {
        Pe.includes(y.key) && (v.current = !0);
      }, R = () => v.current = !1;
      return document.addEventListener("keydown", p), document.addEventListener("keyup", R), () => {
        document.removeEventListener("keydown", p), document.removeEventListener("keyup", R);
      };
    }, []), /* @__PURE__ */ f(
      te,
      {
        asChild: !0,
        ...s,
        focusable: !c,
        active: l,
        children: /* @__PURE__ */ f(
          U,
          {
            disabled: c,
            required: i.required,
            checked: l,
            ...d,
            ...o,
            name: i.name,
            ref: m,
            onCheck: () => i.onValueChange(o.value),
            onKeyDown: C((p) => {
              p.key === "Enter" && p.preventDefault();
            }),
            onFocus: C(o.onFocus, () => {
              var p;
              v.current && ((p = u.current) == null || p.click());
            })
          }
        )
      }
    );
  }
);
z.displayName = K;
var ge = "RadioGroupIndicator", X = a.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: r, ...n } = e, o = $(r);
    return /* @__PURE__ */ f(W, { ...o, ...n, ref: t });
  }
);
X.displayName = ge;
var Ae = B, we = z, xe = X;
const Me = "_radioContainer_yqvmy_1", Oe = "_radioGroup_yqvmy_7", ke = "_radioItem_yqvmy_21", Ge = "_radioItemContainer_yqvmy_25", De = "_radioItem__indicator_yqvmy_58", Te = "_errorMessage_yqvmy_76", h = {
  radioContainer: Me,
  radioGroup: Oe,
  "radioGroup--horizontal": "_radioGroup--horizontal_yqvmy_11",
  "radioGroup--vertical": "_radioGroup--vertical_yqvmy_14",
  radioItem: ke,
  radioItemContainer: Ge,
  radioItem__indicator: De,
  errorMessage: Te
}, Ye = Z(function({
  id: t,
  children: r,
  label: n,
  orientation: o = "vertical",
  required: i,
  disabled: c,
  errorMessage: s,
  onValueChange: d,
  ...u
}, m) {
  return /* @__PURE__ */ P("div", { className: A(h.radioContainer, u.className), children: [
    n && /* @__PURE__ */ f(H, { htmlFor: t, required: i, children: n }),
    /* @__PURE__ */ f(
      Ae,
      {
        id: t,
        name: t,
        ref: m,
        orientation: o,
        required: i,
        disabled: c,
        "data-error": !!s,
        onValueChange: d,
        ...u,
        className: A(
          h.radioGroup,
          u.className,
          h[`radioGroup--${o}`]
        ),
        children: r
      }
    ),
    s && /* @__PURE__ */ f(x, { variant: "caption", className: h.errorMessage, children: s })
  ] });
}), Ze = ({
  id: e,
  value: t,
  children: r,
  customOption: n,
  disabled: o,
  onValueChange: i,
  ...c
}) => {
  const [s, d] = J(t);
  Q(() => {
    n && s && (i == null || i(s));
  }, [s, n, i]);
  const u = (l) => {
    d(l.target.value), i == null || i(l.target.value);
  }, m = () => {
    n && (i == null || i(s));
  };
  return /* @__PURE__ */ P("div", { className: h.radioItemContainer, "data-disabled": o, children: [
    /* @__PURE__ */ f(
      we,
      {
        id: e,
        value: s,
        disabled: o,
        ...c,
        className: h.radioItem,
        children: /* @__PURE__ */ f(xe, { className: h.radioItem__indicator })
      }
    ),
    n && /* @__PURE__ */ f(
      oe,
      {
        id: e,
        placeholder: "Otro",
        value: s,
        onChange: u,
        onClick: m
      }
    ),
    !n && /* @__PURE__ */ f(x, { variant: "body-2", asChild: !0, children: /* @__PURE__ */ f("label", { htmlFor: e, children: r }) })
  ] });
};
export {
  Ye as R,
  Ze as a
};
